import { useForm } from "react-hook-form";
import {
  familyWizardFormDefaultValues,
  familyWizardFormSchema,
  IFamilyWizardFormModel,
} from "../models/familyWizardFormModel";
import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect } from "react";
import { IFamilyWizardViewModel } from "../models/familyWizardViewModel";
import { useFormValidationMessages } from "../../../../../common/infrastructure/hooks/useFormHelper";

export const useFamilyWizardForm = (
  selectedStudioId: number,
  familyId?: string,
  family?: IFamilyWizardViewModel
) => {
  const form = useForm<IFamilyWizardFormModel>({
    defaultValues: familyWizardFormDefaultValues,
    resolver: yupResolver(familyWizardFormSchema),
  });

  useEffect(() => {
    form.setValue("studioId", selectedStudioId);

    if (family) {
      form.setValue("name", family.name);
      form.setValue("members", family.memberIds);
      form.setValue("headOfFamily", family.headOfFamily);
    }

    if (familyId) {
      form.setValue("id", Number(familyId));
    }
  }, [selectedStudioId, family, familyId]);

  useFormValidationMessages<IFamilyWizardFormModel>(form);

  return form;
};
